import { GameSlingoParticleProperties } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/properties/GameSlingoParticlesProperties";
import { Point } from "pixi.js";
export class SlingoParticlesPortraitProperties extends GameSlingoParticleProperties {
    constructor() {
        super();
        this.position.set(8, 357); //values from the GameTicket
        this.scale.set(1 / 0.73);
    }
    getSpawnZone() {
        return GameSlingoParticleProperties.createSpawnZone(new Point(20, 7), 699, 856, 703);
    }
}
//# sourceMappingURL=SlingoParticlesPortraitProperties.js.map